import React, { Component } from 'react';

import { Grid, Card, CardHeader, Avatar, Switch } from '@material-ui/core';
import { BarChartTwoTone, DonutLarge, Timeline } from '@material-ui/icons';
import PropTypes from 'prop-types';

import GraphCard from './GraphCard';
import BarGraph from './BarGraph';
import LineGraph from './LineGraph';
import PlannedCost from './PlannedCost';

import '../../assets/stylesheets/DashboardView.css';

import i18n from '../../i18n';

class AccessoriesProgressInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandView: false,
    };
  }

  handleExpandClick = () => {
    this.setState((prevState) => ({ expandView: !prevState.expandView }));
  };

  generateBarGraphCard = (title, data) => {
    const { expandView } = this.state;
    const { indexBy, formattedSelectedDateRange, keys } = this.props;
    const style = !expandView ? 'progressAccAvgBarGraph' : 'progressBarGraph';

    return (
      <GraphCard
        title={title}
        subheader={formattedSelectedDateRange}
        graphAvatar={<BarChartTwoTone />}
        contentWrapperStyle={data.length ? style : ''}
        content={
          data.length ? (
            <BarGraph keys={keys} indexBy={indexBy} data={data} />
          ) : (
            <p className="centerText">{i18n.t('noData')}</p>
          )
        }
      />
    );
  };

  generateLineGraphCard = (title, data) => {
    const { formattedSelectedDateRange } = this.props;
    const showLineGraphData = data[0].data.length && data[1].data.length;
    return (
      <GraphCard
        title={title}
        subheader={formattedSelectedDateRange}
        graphAvatar={<Timeline />}
        contentWrapperStyle={data.length ? 'progressLineGraph' : ''}
        content={
          showLineGraphData ? (
            <LineGraph data={data} useCustomColors />
          ) : (
            <p className="centerText">{i18n.t('noData')}</p>
          )
        }
      />
    );
  };

  render() {
    const { expandView } = this.state;

    const {
      setAccData,
      totalSetAccData,
      setBagData,
      totalSetBagData,
      setShoeData,
      totalSetShoeData,
      actualVsPlannedRangeDataSet,
      fullTimeCost,
      freelancerCost,
      contractorCost,
      discrepancy,
    } = this.props;

    return (
      <Grid container>
        <Grid item xs={6}>
          <Card className="cardContainer">
            <CardHeader
              avatar={
                <Avatar className="cardAvatar" aria-label="progress-info-icon">
                  <DonutLarge color="secondary" />
                </Avatar>
              }
              title={i18n.t('dashboard:setProgressInfo')}
              subheader={i18n.t('dashboard:setProgressInfoSubtitle')}
              action={
                <Switch
                  checked={expandView}
                  onChange={this.handleExpandClick}
                  color="secondary"
                  name="checkedB"
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                />
              }
            />
          </Card>
        </Grid>
        <Grid item xs={6} />

        <Grid item xs={6}>
          <PlannedCost
            fullTimeCost={fullTimeCost}
            freelancerCost={freelancerCost}
            contractorCost={contractorCost}
            discrepancy={discrepancy}
          />
        </Grid>
        <Grid item xs={6} />

        {!expandView ? (
          <>
            <Grid item xs={3}>
              {this.generateBarGraphCard(
                i18n.t('dashboard:avpAccAllSets'),
                totalSetAccData
              )}
            </Grid>
            <Grid item xs={3}>
              {this.generateBarGraphCard(
                i18n.t('dashboard:avpBagAllSets'),
                totalSetBagData
              )}
            </Grid>
            <Grid item xs={3}>
              {this.generateBarGraphCard(
                i18n.t('dashboard:avpShoeAllSets'),
                totalSetShoeData
              )}
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={12}>
              {this.generateBarGraphCard(
                i18n.t('dashboard:avpAccPerSet'),
                setAccData
              )}
            </Grid>
            <Grid item xs={12}>
              {this.generateBarGraphCard(
                i18n.t('dashboard:avpBagPerSet'),
                setBagData
              )}
            </Grid>
            <Grid item xs={12}>
              {this.generateBarGraphCard(
                i18n.t('dashboard:avpShoePerSet'),
                setShoeData
              )}
            </Grid>
          </>
        )}
        <Grid item xs={12}>
          {this.generateLineGraphCard(
            i18n.t('dashboard:avpAcrossDays'),
            actualVsPlannedRangeDataSet
          )}
        </Grid>
      </Grid>
    );
  }
}

AccessoriesProgressInfo.propTypes = {
  setAccData: PropTypes.arrayOf(PropTypes.object).isRequired,
  totalSetAccData: PropTypes.arrayOf(PropTypes.object).isRequired,
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  setBagData: PropTypes.arrayOf(PropTypes.object).isRequired,
  totalSetBagData: PropTypes.arrayOf(PropTypes.object).isRequired,
  setShoeData: PropTypes.arrayOf(PropTypes.object).isRequired,
  totalSetShoeData: PropTypes.arrayOf(PropTypes.object).isRequired,
  indexBy: PropTypes.string.isRequired,
  formattedSelectedDateRange: PropTypes.string.isRequired,
  actualVsPlannedRangeDataSet: PropTypes.arrayOf(PropTypes.object).isRequired,
  fullTimeCost: PropTypes.number.isRequired,
  freelancerCost: PropTypes.number.isRequired,
  contractorCost: PropTypes.number.isRequired,
  discrepancy: PropTypes.arrayOf(PropTypes.shape({
    studioEmployeeId: PropTypes.number,
    positionId: PropTypes.number,
    availabilityType: PropTypes.string,
    date: PropTypes.string,
  })).isRequired,
};

export default AccessoriesProgressInfo;
